{
  "navigationRoutes": {
    "home": "Главная"
  },
  "menu": {
    "dashboard": "Дашборд",
    "users": "Пользователи",
    "promoCodes": "Промокоды",
    "partners": "Партнёрка",
    "utmBuilder": "Генератор UTM-ссылок",
    "finance": "Финансы"
  },
  "search": {
    "placeholder": "Поиск..."
  }
}
